export const ProductValidationFieldLabels = {
  title: 'Title',
  description: 'Description',
  testScriptEditor: 'Test Script Editor',
  assignTask: 'Assign Task',
  taskFiles: 'Document References',
  assignUserNeed: 'User Need Reference',
  assignDesignInput: 'Design Input Reference',
  attachment: 'Attachments',
  components: 'Components',
  release: 'Release'
} as const;

export type ProductValidationField = keyof typeof ProductValidationFieldLabels;

export const ProductValidationFields: ProductValidationField[] = Object.keys(
  ProductValidationFieldLabels
) as ProductValidationField[];
